<script>

export default {
	name: "Modal-customer",
	props: {
		mode: Number,
		selectedCustomer: Object,
	},
	emits: [
		"close-modal",
		"modify-customer",
    "delete-member"
	],
  data() {
    return {
      localCustomer: { ...this.selectedCustomer },
      generatedResetLink: '',
      showResetLinkModal: false
    }
  },
  watch: {
    selectedCustomer: {
      handler(newVal) {
        this.localCustomer = { ...newVal }
      },
      deep: true,
      immediate: true
    }
  },
	methods: {
    /**
     * Title      : Member 정보수정
     * Status     : Actived
     * Description: 회원정보를 수정한다.
     */
		modifyCustomer() {
			this.$log.debug("[ Admin / Customer modal / modifyCustomer ] ", this.localCustomer)
			this.$emit("modify-customer", this.localCustomer)
			this.$emit("close-modal")
		},


    copyToClipboard(text) {
      if (navigator?.clipboard?.writeText) {
        return navigator.clipboard.writeText(text)
      }

      const textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.position = 'fixed'
      textArea.style.opacity = '0'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      return Promise.resolve()
    },

    showResetLinkDialog(resetUrl) {
      this.generatedResetLink = resetUrl
      this.showResetLinkModal = true
    },

    async copyResetLinkFromDialog() {
      if (!this.generatedResetLink) return
      try {
        await this.copyToClipboard(this.generatedResetLink)
        this.$q.notify({
          type: 'positive',
          message: '링크를 클립보드에 복사했습니다.',
          position: 'top',
          timeout: 2000,
        })
      } catch (e) {
        this.$q.notify({
          type: 'negative',
          message: '클립보드 복사에 실패했습니다.',
          position: 'top',
          timeout: 2000,
        })
      }
    },

    /**
     * Title      : Member 비밀번호 재설정 링크 생성
     * Status     : Actived
     * Description: 관리자가 비밀번호 재설정 링크를 생성하고 복사하여 회원에게 전달한다.
     */
    async generateResetLink() {
      let payload = {
        memberId: this.localCustomer.id
      }

      let config = {
        method  : "POST",
        url     : "/api/admin/generate-reset-link",
        data    : payload,
        name    : "[ Axios / Member 비밀번호 재설정 링크 생성 ]"
      }

      await this.$http(config)
        .then(async (res) => {
          const resetUrl = res?.data?.data?.resetUrl || ''
          if (!resetUrl) {
            throw new Error('resetUrl is empty')
          }

          this.generatedResetLink = resetUrl
          await this.copyToClipboard(resetUrl)

          this.$q.notify({
            type: 'positive',
            message: '비밀번호 재설정 링크를 생성하고 클립보드에 복사했습니다.',
            position: 'top',
            timeout: 3000,
          })

          this.showResetLinkDialog(resetUrl)

        }).catch(res => {
          this.$log.debug(`${config.name} 실패`, res)
          this.$q.notify({
            type: 'negative',
            message: res?.response?.data?.message || '링크 생성 중 오류가 발생했습니다.',
            position: 'top',
            timeout: 3000,
          })
        })

    },
    

    /**
     * Title      : Member 삭제
     * Status     : Actived
     * Description: 회원정보를 삭제한다. !!!! 절대 복구불가이니 유의할 것
     */
    deleteMember() {
      this.$emit("delete-member")
    }
	},
  mounted(){
    // this.$getMemberLevelList()
    this.$getCodeList('NATION')
    this.$getCodeList('AUTHLV')
  }
}
</script>


<template>

  <q-card class="card-size">
    <q-toolbar>
      <q-toolbar-title>
        <div class="text-h6">고객정보수정</div>
      </q-toolbar-title>
      <q-btn flat v-close-popup round dense icon="close" @click="showModalNow = !showModalNow" />
    </q-toolbar>
    <div class="row q-gutter-md q-px-md">
      <div class="col">
        <q-select
          v-model="localCustomer.authLevel"
          label="고객등급"
          :options="this.$store.getters.getAuthLevelList"
          emit-value
          map-options/>
      </div>
      <div class="col">
        <q-input 
          v-model="localCustomer.id"
          label="고객번호"
          disable/>    
      </div>
    </div>
    <div class="row q-gutter-md q-px-md">
      <div class="col">
        <q-input 
          v-model="localCustomer.email"
          label="이메일" 
          maxlength="100"/>
      </div>
    </div>
    <div class="row q-gutter-md q-px-md">
      <div class="col">
        <q-input 
          v-model="localCustomer.lName"
          label="성"
          maxlength="20"/>    
      </div>
      <div class="col">
        <q-input 
          v-model="localCustomer.fName"
          label="이름"
          maxlength="20"/>    
      </div>
    </div>
    <div class="row q-gutter-md q-px-md">
      <div class="col">
        <!-- <q-input 
          v-model="selectedCustomer.country"
          label="국가코드"
          placeholder="ex)'KOR', 'AUS'"/> -->

        <q-select
          :model-value="localCustomer.country"
          class="mobile-country-select"
          label="국가코드"
          :options="this.$store.getters.getNationCodeList"
          behavior="menu"
          emit-value
          map-options />

      </div>
      <div class="col">
        <q-input 
          v-model="localCustomer.mobile"
          mask="###-####-####"
          label="모바일"/>
      </div>
      <div class="col">
        <q-input 
          v-model="localCustomer.regDate"
          disable
          label="가입일"/>
      </div>
    </div>
    <div class="row q-mt-lg q-pa-md q-gutter-sm">
      <q-btn
        v-if="mode === 1"
        label="삭제"
        style="flex:0.3;"
        color="red"
        @click="deleteMember">
      </q-btn>
      <q-btn
        v-if="mode === 1"
        label="비밀번호 재설정 링크"
        style="flex:0.5;"
        color="info"
        @click="generateResetLink">
      </q-btn>
      <q-btn
        v-if="mode === 1"
        label="수정"
        style="flex:1;"
        color="primary"
        @click="modifyCustomer">
      </q-btn>
    </div>
  </q-card>

  <q-dialog v-model="showResetLinkModal" persistent>
    <q-card class="reset-link-dialog-card">
      <q-toolbar>
        <q-toolbar-title>
          <div class="text-h6">비밀번호 재설정 링크</div>
        </q-toolbar-title>
        <q-btn flat round dense icon="close" @click="showResetLinkModal = false" />
      </q-toolbar>

      <q-card-section class="q-pt-none">
        <div class="text-body2 q-mb-sm">
          아래 링크를 대상 회원에게 전달하세요.
        </div>

        <div class="reset-link-box">
          {{ generatedResetLink }}
        </div>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat color="primary" label="Copy to clipboard" @click="copyResetLinkFromDialog" />
        <q-btn color="primary" label="닫기" @click="showResetLinkModal = false" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<style scoped>
.reset-link-dialog-card {
  width: min(920px, 92vw);
  max-width: 92vw;
}

.reset-link-box {
  max-height: 220px;
  overflow: auto;
  padding: 10px 12px;
  border: 1px solid #d7dde6;
  border-radius: 8px;
  background: #f8fafc;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 13px;
  line-height: 1.5;
  word-break: break-all;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}
</style>
